<div nz-form [nzLayout]="layout">
  <nz-form-item [ngClass]="infoText ? 'info-form' : ''">
    @if (label) {
    <nz-form-label
      [attr.aria-labelledby]="label"
      [nzRequired]="required || _isRequired"
      [ngClass]="{ error: control?.hasError }"
      [nzFor]="formControlName"
      [nzTooltipTitle]="labeInfoText"
      [nzTooltipIcon]="labelInfoIcon"
      >{{ label }}</nz-form-label
    >
    } @if (!['editor', 'file'].includes(type)) {
    <nz-form-control
      [nzValidateStatus]="status"
      [nzHasFeedback]="showFeedback"
      [nzExtra]="infoText"
      [nzWarningTip]="warningText"
      [nzSuccessTip]="successText"
      [nzErrorTip]="errorTpl"
    >
      <!-- text | email | password | number | 'tell'-->
      @if (['text', 'url', 'email', 'password'].includes(type)) {
      <nz-input-group
        [nzSuffix]="suffixTemplate"
        [nzPrefix]="prefixTemplate"
        (mouseenter)="inputFocus = true"
        (mouseleave)="inputFocus = false"
      >
        <input
          (focusin)="inputFocus = true"
          (focusout)="inputFocus = false"
          [formControl]="control"
          [max]="max"
          [attr.maxlength]="maxLength"
          [min]="min"
          [attr.minlength]="minLength"
          [placeholder]="placeholder || label"
          [step]="step"
          [type]="type"
          nz-input
          [attr.aria-label]="formControlName"
          [attr.id]="formControlName"
          [attr.aria-describedby]="placeholder || label"
        />
      </nz-input-group>
      } @if (type === 'tel') {
      <un-phone-input
        [autoComplete]="autoComplete"
        [placeholder]="placeholder"
        [formControl]="control"
      ></un-phone-input>
      } @if (type === 'number') {

      <nz-input-number
        (focusin)="inputFocus = true"
        (focusout)="inputFocus = false"
        [formControl]="control"
        [nzPlaceHolder]="placeholder || label"
        [nzStep]="step"
        [attr.aria-label]="formControlName"
        [attr.id]="formControlName"
        [attr.aria-describedby]="placeholder || label"
      >
        @if (prefixIcon || prefixIcon) {
        <span nzInputAddonBefore>
          @if (prefixIcon) {
          <i [nzType]="prefixIcon" nz-icon></i>
          } @if (prefixText) {
          <span>{{ prefixText }}</span>
          } </span
        >} @if (suffixIcon || suffixIcon) {
        <span nzInputAddonAfter>
          @if (suffixIcon) {
          <i [nzType]="suffixIcon" nz-icon></i>
          } @if (suffixText) {
          <span>{{ suffixText }}</span>
          } </span
        >}
      </nz-input-number>
      }
      <!-- Textarea -->
      <ng-container>
        @if (type === 'textarea' && maxLength) {
        <nz-textarea-count [nzMaxCharacterCount]="maxLength">
          <textarea
            [attr.defaultValue]="value"
            [formControl]="control"
            (ngModelChange)="writeValueNonReactive($event)"
            [placeholder]="placeholder || label"
            [rows]="rows"
            nz-input
          ></textarea>
        </nz-textarea-count>
        } @if (type === 'textarea' && !maxLength) {
        <textarea
          [attr.defaultValue]="value"
          [formControl]="control"
          (ngModelChange)="writeValueNonReactive($event)"
          [placeholder]="placeholder || label"
          [rows]="rows"
          nz-input
        ></textarea>
        }
      </ng-container>
      @if (type === 'auto-complete' && autoCompleteType === 'text') {
      <nz-input-group
        [nzSuffix]="suffixTemplate"
        [nzPrefix]="prefixTemplate"
        (mouseenter)="inputFocus = true"
        (mouseleave)="inputFocus = false"
      >
        <input
          nz-input
          [formControl]="control"
          [nzAutocomplete]="auto"
          (ngModelChange)="keyUp($event)"
        />
        <nz-autocomplete #auto [nzBackfill]="true">
          @for (option of _options; track option) {
          <nz-auto-option [nzValue]="option.value">{{
            option.label
          }}</nz-auto-option>
          }
        </nz-autocomplete>
      </nz-input-group>
      }
      <!-- Select -->
      @if ( type === 'select' || (type === 'auto-complete' && autoCompleteType
      === 'select') ) {
      <nz-select
        [nzMaxTagCount]="0"
        [nzMaxTagPlaceholder]="tagPlaceHolder"
        [nzAllowClear]="showClearIcon"
        [nzMode]="selectMode"
        [nzServerSearch]="type === 'auto-complete' ? true : null"
        [nzPlaceHolder]="placeholder || label"
        [formControl]="control"
        (ngModelChange)="writeValueNonReactive($event)"
        [nzShowSearch]="
          showSearch ||
          (options.length && options.length > 8) ||
          type === 'auto-complete'
        "
        [nzDropdownRender]="renderTemplate"
        (nzOnSearch)="keyUp($event)"
        (nzScrollToBottom)="loadMore()"
        class="auto-complete"
        [nzSuffixIcon]="suffixTemplate"
        [nzShowArrow]="true"
      >
        @for (option of _options; track option) {
        <nz-option
          [nzLabel]="option.label"
          [nzValue]="option.value"
          nzCustomContent
        >
          @if (selectionIconTheme && option.value) {
          <un-icon
            [type]="option.value"
            [theme]="selectionIconTheme"
            class="m-r-8"
          ></un-icon>
          }
          <span>{{ option.label }}</span>
        </nz-option>
        } @if (isLoading) {
        <nz-option nzDisabled nzCustomContent>
          <i nz-icon nzType="loading" class="loading-icon"></i>
          <span i18n>Loading Data...</span>
        </nz-option>
        }
        <ng-template #tagPlaceHolder
          >@if (!isLoading && control) {
          <span i18n="@@slected" class="c-primary t-medium t-small selected"
            >{{ control?.value?.length }} selected
          </span>
          }</ng-template
        >
        <ng-template #renderTemplate>
          @if (isLoadingMore) {
          <nz-spin></nz-spin>
          }
        </ng-template>
      </nz-select>
      }
      <!-- Radio -->
      @if (type === 'radio') {
      <nz-radio-group
        [ngClass]="layout"
        [formControl]="control"
        (ngModelChange)="writeValueNonReactive($event)"
        [nzName]="formControlName"
        [ngModel]="value"
        nz-input
      >
        @for (option of _options; track option) {
        <label [nzValue]="option.value" nz-radio>
          {{ option.label }}
        </label>
        }
      </nz-radio-group>
      }
      <!-- Checkbox -->
      @if (type === 'checkbox') {
      <nz-checkbox-group
        [ngClass]="layout"
        [(ngModel)]="checkOptions"
        (ngModelChange)="checkboxChange($event)"
      >
      </nz-checkbox-group>
      }
      <!-- date picker -->
      @if (type === 'date') {
      <nz-date-picker
        [formControl]="control"
        [nzPlaceHolder]="placeholder || label"
        [nzDisabledDate]="disableDate"
        [nzFormat]="dateFormat"
        [nzMode]="dateMode"
      ></nz-date-picker>
      } @if (type === 'date-range') {
      <nz-range-picker
        [formControl]="control"
        [nzDisabledDate]="disableDate"
        [nzFormat]="dateFormat"
        [nzMode]="dateMode"
        [nzRenderExtraFooter]="placeholder"
      ></nz-range-picker>
      }
    </nz-form-control>
    }

    <!-- <div
          [formControl]="control"
          [ngxSummernote]="editorConfig"
          *ngIf="type === 'editor' && editorConfig"
          [ngClass]="{ error: control?.touched && control?.invalid }"
        ></div> -->
    @if (type === 'editor') {
    <quill-editor
      [formControl]="control"
      [ngClass]="{ error: control?.touched && control?.invalid }"
      [required]="!!required"
    ></quill-editor>
    } @if (type === 'file') {
    <un-file-input
      [formControl]="control"
      [multiple]="multiple"
      [accept]="accept"
      [maxLength]="maxLength"
      [bucket]="bucket"
      [fileValue]="fileValue"
      [documentType]="documentType"
      [documentTypes]="documentTypes"
      [recommendedSize]="recommendedSize"
      [size]="size"
      [uploadType]="uploadType"
      [rounded]="rounded"
    ></un-file-input>
    }
  </nz-form-item>
</div>

<ng-template #suffixTemplate>
  @if (suffixText) {
  <span>{{ suffixText }}</span>
  } @if (maxLength && type !== 'number' && !suffixText) {
  <span>{{ control?.value?.length }}/{{ maxLength }}</span>
  } @if (suffixIcon) {
  <span [nzType]="suffixIcon" nz-icon></span>
  } @if (!suffixIcon && ['select', 'auto-complete'].includes(type)) {
  <span nzType="down" nz-icon></span>
  } @if ( showClearIcon && inputFocus && !showFeedback && ['text', 'url',
  'email', 'number', 'password'].includes(type) && control?.value ) {
  <span
    nz-icon
    class="ant-input-clear-icon close"
    (mouseenter)="inputFocus = true"
    nzTheme="fill"
    nzType="close-circle"
    (click)="reset()"
  ></span>
  }
</ng-template>

<ng-template #prefixTemplate>
  @if (prefixIcon) {
  <i [nzType]="prefixIcon" nz-icon></i>
  } @if (prefixText) {
  <span>{{ prefixText }}</span>
  }
</ng-template>

<ng-template #errorTpl let-control>
  @if (showErrorMessage) {
  <span>
    @if (showErrorIcon()) {
    <span nz-icon nzType="warning" nzTheme="fill"></span>
    } @if (control?.hasError('maxlength') && maxLength) {
    <ng-container i18n>
      Max length is
      {{ control?.errors?.maxlength.requiredLength }}.</ng-container
    >
    } @if (control?.hasError('minlength') && minLength) {
    <ng-container i18n>
      Min length is
      {{ control?.errors?.minlength.requiredLength }}.</ng-container
    >
    } @if (control?.hasError('max') && max) {
    <ng-container i18n> Max is {{ control?.errors?.max.max }}.</ng-container>
    } @if (control?.hasError('min') && min) {
    <ng-container i18n> Min is {{ control?.errors?.min.min }}.</ng-container>
    } @if (control?.hasError('required')) {
    <ng-container i18n> Input is required.</ng-container>
    } @if (control?.hasError('email')) {
    <ng-container i18n> Enter a valid email </ng-container>
    } @if (control?.errors?.password?.errors; as errors) {
    <ng-container i18n>
      @if (errors.length > 0) {
      <span>{{ errors[0] }}</span>
      }
    </ng-container>
    } @if (control?.errors?.mustMatch) {
    <ng-container i18n>
      Must match: {{ control?.errors.mustMatch | titlecase }}
    </ng-container>
    } @if (control?.errors?.isBigger) {
    <ng-container i18n>
      Must be greater than: {{ control?.errors.isBigger | titlecase }}
    </ng-container>
    }
  </span>
  }
</ng-template>
